import { Box, Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Stack } from '@mui/system';
import { useGetOrderQuery } from '../../features/model/orderSlice';
import { OrderEditCard } from '../../components/OrderEditCard';
import Loading from '../../components/Loading';
import POHistoryView from '../../components/POHistoryView';
import PurchaseOrderForm from './PurchaseOrderForm';
import { PurchaseOrderAdminActions } from './PurchaseOrderAdminActions';

const PurchaseOrderEditView = () => {
    let params = useParams();
    const {data: order, error, isLoading } = useGetOrderQuery(params.orderId)
    if (isLoading) {
        return <Loading />;
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <Grid container alignItems="stretch" justifyItems="space-between" spacing={2}>
            <Grid item display="flex" >
                <Box width="100%">
                    <OrderEditCard order={order} />
                </Box>
            </Grid>
            <Grid item sx={{display: "flex", flexDirection: "column"}} >
                <POHistoryView order={order} />
            </Grid>
        </Grid>
        <PurchaseOrderAdminActions order={order}/>
        <PurchaseOrderForm hideHistory={true} showSums={true} />
    </Stack>;
}

export { PurchaseOrderEditView };
